import Dark from 'quasar/src/plugins/Dark.js';;

export const ui = {
   namespaced: true,
   state: {
      dark: false,
      toolbarTitle: '',
      tokenLogin: false,
      broadcastEnabled: false,
   },
   getters: {
      broadcastEnabled: state => state.broadcastEnabled,
   },
   mutations: {
      toggleDark(state) {
         state.dark = !state.dark;
         Dark.set(state.dark);
      },
      setDark(state, dark) {
         state.dark = dark;
         Dark.set(dark);
      },
      setToolbarTitle(state, title) {
         state.toolbarTitle = title;
      },
      setBroadcastEnabled(state, enabled) {
         state.broadcastEnabled = enabled;
      },
   },
};
